<template>
  <div>
    <a-modal v-model="visible" title="Edit Hostel" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update</a-button>
      </template>
      <a-form class="mb-4" :form="form">
        <a-form-item label="Hostel Name">
          <a-input
            placeholder="Hostel Name"
            v-decorator="['name', {rules: [{ required: true, message: 'Please input a hostel name!' },
            {max: 30, message: 'Must not exceed 30 characters!'}]}]"
          />
        </a-form-item>
        <a-form-item label="Hostel Type">
          <a-select v-decorator="['type', { rules: [{ required: true, message: 'Hostel type is required!!' }] } ]" placeholder="Hostel Type">
            <a-select-option v-for="hostelType in hostelTypes" :value="hostelType.value" :key="hostelType.value">
              {{ hostelType.name }}
            </a-select-option>
          </a-select>
        </a-form-item><a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description', {rules: [{max: 100, message: 'Must not exceed 100 characters!'}]}]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { hostelTypes } from '@/services/globaldata'
export default {
  name: 'EditHostel',
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      oldrecord: {},
      newrecord: {},
      hostelTypes,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openEditForm', this.showForm)
  },
  methods: {
    moment,
    showForm: function(record) {
      this.visible = true
      this.oldrecord = record
      setTimeout(() => {
        this.form.setFieldsValue({
          'name': record.name,
          'type': record.type,
          'description': record.description,
        })
      }, 50)
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    handleEdit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http
            .patch(`/api/hostel/${this.oldrecord.id}`, {
              name: values.name,
              type: values.type,
              description: values.description,
            })
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onEdited')
                this.form.resetFields()
                this.$notification['success']({
                  message: 'Successfully edited',
                  description: 'Hostel edited successfully!',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data.',
                })
              }
              this.form.resetFields()
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
  },
}
</script>
